import React from 'react';
import Header from '../components/Header/Header';
import Services from '../components/Services/Services';
import { useTranslation } from 'react-i18next';

const ServicesPage = () => {
  const { t } = useTranslation();
  return (
    <div className="services" activePage="/services">
      <Header />
      <div className="page-services__container container">
        <h2 className="page-services__title">{t('what_we_offer_title')}</h2>
      </div>
      <Services title={false} />
    </div>
  );
};

export default ServicesPage;
